<template>
  <div>
    <info-text i18n="integrations.helper.inventory-blockings.create" />
    <va-create-layout>
      <inventory-blockings-form :item="item" />
    </va-create-layout>
  </div>
</template>

<script>
import InfoText from "@/components/helper/InfoText";
export default {
  components: { InfoText },
  props: ["resource", "title", "item"]
};
</script>
